export default __webpack_public_path__ + "static/media/headimg.37fac9fb.jpg";